export const removeTooltipText = 'Delete this cell';
export const editTooltipText = 'Edit this cell';
